import { Record } from 'immutable';

const EventSortRecord = Record({
  sortField: null,
  sortDirection: null
});

export class EventSort extends EventSortRecord {
  sortField: string;
  sortDirection: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/event-sort.ts